// Interacciones de la portada: línea de tiempo del método (el raíl se
// rellena con el scroll) y carrusel de opiniones. Ambas degradan a
// contenido estático y completamente legible si el JS no se ejecuta.

/** Rellena el raíl según el avance del scroll sobre la lista de fases. */
function initTimeline() {
	const timeline = document.querySelector("[data-timeline]");
	if (!timeline) return;

	const fill = timeline.querySelector("[data-timeline-fill]");
	const items = [...timeline.querySelectorAll("[data-timeline-item]")];
	if (!fill || !items.length) return;

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		fill.style.height = "100%";
		items.forEach((item) => item.classList.add("is-reached"));
		return;
	}

	let ticking = false;

	const update = () => {
		const rect = timeline.getBoundingClientRect();
		const anchor = window.innerHeight * 0.55;
		const progress = Math.max(0, Math.min(1, (anchor - rect.top) / Math.max(rect.height, 1)));
		fill.style.height = `${(progress * 100).toFixed(2)}%`;

		for (const item of items) {
			const node = item.getBoundingClientRect();
			item.classList.toggle("is-reached", node.top + node.height / 2 <= anchor);
		}
		ticking = false;
	};

	window.addEventListener(
		"scroll",
		() => {
			if (ticking) return;
			ticking = true;
			window.requestAnimationFrame(update);
		},
		{ passive: true }
	);
	window.addEventListener("resize", update);
	update();
}

/** Carrusel de opiniones: puntos, flechas y arrastre táctil. */
function initQuotes() {
	const root = document.querySelector("[data-quotes]");
	if (!root) return;

	const track = root.querySelector("[data-quotes-track]");
	const dots = [...root.querySelectorAll("[data-quotes-dot]")];
	const pages = track ? track.children.length : 0;
	if (!track || pages < 2) return;

	let index = 0;

	const go = (next) => {
		index = (next + pages) % pages;
		track.style.transform = `translateX(-${index * 100}%)`;
		dots.forEach((dot, i) => dot.setAttribute("aria-current", i === index ? "true" : "false"));
	};

	dots.forEach((dot, i) => dot.addEventListener("click", () => go(i)));
	root.querySelector("[data-quotes-prev]")?.addEventListener("click", () => go(index - 1));
	root.querySelector("[data-quotes-next]")?.addEventListener("click", () => go(index + 1));

	// Deslizamiento horizontal en táctil.
	let startX = null;
	track.addEventListener("touchstart", (event) => {
		startX = event.touches[0].clientX;
	}, { passive: true });
	track.addEventListener("touchend", (event) => {
		if (startX === null) return;
		const delta = event.changedTouches[0].clientX - startX;
		if (Math.abs(delta) > 48) go(index + (delta < 0 ? 1 : -1));
		startX = null;
	}, { passive: true });
}

export function initHome() {
	initTimeline();
	initQuotes();
}
